import modalActions from "actions/modal";
import cn from "classnames";
import ChatBody from "components/shared/chat/body";
import { Transition } from "components/shared/column";
import DropdownBtn from "components/shared/dropdown";
import Loader from "components/shared/loader";
import { dateToView } from "helpers/date";
import { chatTypesEnum, relationToTypesEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { connect } from "helpers/redux";
import { formatNumber } from "helpers/system";
import React, { useEffect, useState } from "react";
import { CustomScroll } from "react-custom-scroll";
import { useParams } from "react-router";
import { Link } from "react-router-dom";
import { createAppendix, delItem, getItem } from "sources/books/registries";
import CreateRegistryInvoiceForm from "./createInvoiceForm";
import CreateRegistryUniversalTransferDocumentForm from "./createUniversalTransferDocumentForm";
import RegistryManualForm from "./manualForm";

const tabs = {
    registry: "registry",
    history: "history",
};

const RelatedObject = ({ item }) => {
    switch (item.relatedToType) {
        case relationToTypesEnum.Bid:
            return <Link to={paths.bidShow("bid", item.relatedToId)}>Заявка: {item.relatedToId}</Link>;
        case relationToTypesEnum.DistributionBid:
            return <Link to={paths.distributionBidShow(item.relatedToId)}>Заказ: {item.relatedToId}</Link>;
        default:
            return item.relatedToId || "";
    }
};

const RegistriesShow = (props) => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState({});
    const [activeTab, setActiveTab] = useState(tabs.registry);
    const { id } = useParams();

    const getData = () => {
        setLoading(true);
        getItem(id)
            .then((res) => setData(res || {}))
            .catch(() => undefined)
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        getData();
    }, [id]);

    useEffect(() => {
        if (!data.chatId && activeTab === tabs.history) {
            setActiveTab(tabs.registry);
        }
    }, [data.chatId, activeTab]);

    const openInvoiceForm = () => {
        props.modal({
            name: "default",
            title: "Создать реестровый счет",
            windowMod: "sm",
            CustomBody: CreateRegistryInvoiceForm,
            bodyData: { id, onSuccess: getData },
        });
    };

    const openUniversalTransferDocumentForm = () => {
        props.modal({
            name: "default",
            title: "Создать УПД по реестру",
            windowMod: "md",
            CustomBody: CreateRegistryUniversalTransferDocumentForm,
            bodyData: { id, onSuccess: getData },
        });
    };

    const handleAppendix = () => {
        setLoading(true);
        createAppendix({ id }).then(() => getData());
    };

    const openEditForm = () => {
        props.modal({
            name: "default",
            title: "Редактировать реестр перевозок",
            windowMod: "wide",
            CustomBody: RegistryManualForm,
            bodyData: { data, onSuccess: getData },
        });
    };

    const handleDelete = (deleteRelatedDocuments) => {
        setLoading(true);
        props.modal({
            name: "confirm",
            title: "Удаление реестра",
            text: "Вы действительно хотите удалить реестр?",
            onSuccessAction: () => props.history.push(paths.registries),
            onCloseAction: () => setLoading(false),
            buttons: { confirm: "Да", cancel: "Нет" },
            action: () => delItem({ id, deleteRelatedDocuments }),
        });
    };

    const renderHead = () => (
        <div className="book-list__head">
            <div className="book-show__close close close--sm" onClick={() => props.history.push(paths.registries)} />
            <div className="book-show__title">Реестр перевозок {data.id || ""}</div>
        </div>
    );

    const renderActions = () => {
        const removeItems = [
            { text: "Удалить только реестр", action: () => handleDelete(false) },
            { text: "Удалить со связанными документами", action: () => handleDelete(true) },
        ];
        return (
            <div className="mb-3">
                <div className="btn btn-xs btn-outline-primary mr-2" onClick={openEditForm}>
                    Редактировать
                </div>
                {!data.universalTransferDocumentId && (
                    <div className="btn btn-xs btn-outline-primary mr-2" onClick={openUniversalTransferDocumentForm}>
                        Создать УПД
                    </div>
                )}
                <div className="btn btn-xs btn-outline-primary mr-2" onClick={openInvoiceForm}>
                    Создать счет
                </div>
                <div className="btn btn-xs btn-outline-primary mr-2" onClick={handleAppendix}>
                    Создать приложение
                </div>
                <DropdownBtn cname="btn btn-xs btn-outline-danger" text="Удалить" items={removeItems} />
            </div>
        );
    };

    const renderTabs = () => {
        if (!data.chatId) {
            return null;
        }
        const items = [
            { value: tabs.registry, label: "Реестр" },
            { value: tabs.history, label: "История и файлы" },
        ];
        return (
            <ul className="nav nav-tabs mb-0 font-size-14">
                {items.map((item) => (
                    <li key={item.value} className="nav-item">
                        <button
                            type="button"
                            className={cn("nav-link", { active: activeTab === item.value })}
                            onClick={() => setActiveTab(item.value)}
                        >
                            {item.label}
                        </button>
                    </li>
                ))}
            </ul>
        );
    };

    const renderItems = () => {
        const items = data.items || [];
        return (
            <div className="table-responsive">
                <table className="table table-sm table-bordered">
                    <thead>
                        <tr>
                            <th>#</th>
                            <th>Связанный объект</th>
                            <th>Договор-заявка</th>
                            <th>Дата завершения</th>
                            <th>Сумма без НДС</th>
                            <th>Ставка НДС</th>
                            <th>НДС</th>
                            <th>Сумма с НДС</th>
                            <th>Комментарий</th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((item, index) => (
                            <tr key={item.id || index}>
                                <td>{index + 1}</td>
                                <td>
                                    <RelatedObject item={item} />
                                </td>
                                <td>
                                    {item.contractUniversalDocumentId && (
                                        <Link to={paths.financesDocumentsShow(item.contractUniversalDocumentId)}>
                                            {item.contractUniversalDocumentId}
                                        </Link>
                                    )}
                                </td>
                                <td>{dateToView(item.completedAt)}</td>
                                <td>{formatNumber(item.amountWithoutVat)}</td>
                                <td>
                                    {item.vatRate === null || item.vatRate === undefined
                                        ? "Без НДС"
                                        : `${item.vatRate}%`}
                                </td>
                                <td>{formatNumber(item.vatAmount)}</td>
                                <td>{formatNumber(item.amount)}</td>
                                <td>{item.comment}</td>
                            </tr>
                        ))}
                        {!items.length && (
                            <tr>
                                <td colSpan={9}>Нет данных для отображения</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        );
    };

    const renderBody = () => (
        <div>
            {renderActions()}
            <table className="table table-sm">
                <tbody>
                    <tr>
                        <td>ID</td>
                        <td>{data.id}</td>
                    </tr>
                    <tr>
                        <td>Дата реестра</td>
                        <td>{dateToView(data.date)}</td>
                    </tr>
                    <tr>
                        <td>Период</td>
                        <td>
                            {dateToView(data.from)} - {dateToView(data.to)}
                        </td>
                    </tr>
                    <tr>
                        <td>Контрагент</td>
                        <td>{data.counterparty?.displayName || data.counterparty?.name}</td>
                    </tr>
                    <tr>
                        <td>Юрлицо</td>
                        <td>{data.legalPerson?.displayName || data.legalPerson?.name}</td>
                    </tr>
                    <tr>
                        <td>УПД</td>
                        <td>
                            {data.universalTransferDocumentId && (
                                <Link to={paths.universalTransferDocumentsShow(data.universalTransferDocumentId)}>
                                    {data.universalTransferDocumentId}
                                </Link>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>Реестровый счет</td>
                        <td>
                            {data.invoiceUniversalDocumentId && (
                                <Link to={paths.financesDocumentsShow(data.invoiceUniversalDocumentId)}>
                                    {data.invoiceUniversalDocumentId}
                                </Link>
                            )}
                        </td>
                    </tr>
                    <tr>
                        <td>Комментарий</td>
                        <td>{data.comment}</td>
                    </tr>
                    {!!data.files?.length && (
                        <tr>
                            <td>Файлы</td>
                            <td>
                                {data.files.map((item) => (
                                    <a key={item.id} className="d-block" href={item.accessUrlLink} download>
                                        {item.originalFileName}
                                    </a>
                                ))}
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
            <h6>Перевозки</h6>
            {renderItems()}
        </div>
    );

    const renderHistory = () => (
        <div className="chat-layout px-0 py-0 h-100">
            <ChatBody
                key={data.chatId}
                chatId={data.chatId}
                info={{ type: chatTypesEnum.DocumentFlowChat }}
                modal={props.modal}
                profile={props.profile}
                readOnly
                updateChats={() => undefined}
                withoutShadow
            />
        </div>
    );

    const renderTabBody = () => {
        if (!data.chatId) {
            return <CustomScroll heightRelativeToParent="100%">{renderBody()}</CustomScroll>;
        }
        return (
            <div className="h-100 d-flex flex-column">
                {renderTabs()}
                <div className="border border-top-0 bg-white p-3 flex-grow-1" style={{ minHeight: 0 }}>
                    {activeTab === tabs.registry ? (
                        <CustomScroll heightRelativeToParent="100%">{renderBody()}</CustomScroll>
                    ) : (
                        renderHistory()
                    )}
                </div>
            </div>
        );
    };

    return (
        <div className="page-content">
            <Transition dir="full" {...props}>
                <div className="page-book__show book-show">
                    {renderHead()}
                    <div className="book-show__body">
                        {loading ? <Loader prefix="absolute-center" /> : renderTabBody()}
                    </div>
                </div>
            </Transition>
        </div>
    );
};

function container(Component) {
    const mapState = (state) => ({
        profile: state.profile.profile,
    });
    const mapDispatch = (dispatch) => ({
        modal: (params) => dispatch(modalActions.open(params)),
    });

    return connect(mapState, mapDispatch)(Component);
}

export default container(RegistriesShow);
